import React from "react";
import GradientButton from "../../UIComponents/GradientButton";
import { useState,useRef } from "react";

export default function BusinessLoanSection() {

const mobileVideoRef = useRef(null);
const desktopVideoRef = useRef(null);
const [isMobilePlaying, setIsMobilePlaying] = useState(false);
const [isDesktopPlaying, setIsDesktopPlaying] = useState(false);

const toggleMobilePlay = () => {
  if (!mobileVideoRef.current) return;
  if (isMobilePlaying) {
    mobileVideoRef.current.pause();
  } else {
    mobileVideoRef.current.play();
  }
  setIsMobilePlaying(!isMobilePlaying);
};

const toggleDesktopPlay = () => {
  if (!desktopVideoRef.current) return;
  if (isDesktopPlaying) {
    desktopVideoRef.current.pause();
  } else {
    desktopVideoRef.current.play();
  }
  setIsDesktopPlaying(!isDesktopPlaying);
};



  return (
    <section className="w-full px-4 py-[40px] xs:py-[45px] sm:py-[120px] min-h-screen flex flex-col items-center text-center ">
      {/* Badges */}
      <div className="flex w-full flex-wrap justify-center gap-2 mb-4">
        <GradientButton
          iconSrc="/assets/img/instant.png" // Example path
          altText="bolt"
          text="Instant Approvals"
          gradientColors="from-[#FFF200] via-[#FF7300] to-[#FF00AA]"
          onClick={() => console.log("Clicked")}
        />
        <GradientButton
          iconSrc="/assets/img/quick.png" // Example path
          altText="bolt"
          text="Quick Disbursals"
          gradientColors="from-[#500DCE] via-[#CEA0CE] to-[#EB6FE2]"
          onClick={() => console.log("Clicked")}
        />
        <GradientButton
          iconSrc="/assets/img/low.png" // Example path
          altText="bolt"
          text="Low interest rates"
          gradientColors="from-[#6E80B0] via-[#8CBEB2] to-[#CDD7AA]"
          onClick={() => console.log("Clicked")}
        />
      </div>

      {/* Content */}
      <p className="max-w-[90%] text-2xl xs:text-xl leading-[1.3] font-atkinson  mb-[100px] sm:max-w-4xl">
        Running a successful business requires capital—whether it’s for
        expansion, inventory, hiring, or managing cash flow. A Business Loan can
        give you <em className="font-pp-hatton">the financial boost</em> you need to scale operations,
        seize new opportunities, and navigate tough times with confidence.
      </p>

      {/* Mobile View */}
      <div className="w-full mt-5 max-w-sm sm:hidden">
        <div className="relative rounded-xl overflow-hidden">
          <video
            src="/assets/video/istockphoto-2166378329-640_adpp_is.mp4"

            className="w-full h-auto object-cover"
            ref={mobileVideoRef}
            controls={false}
            loop
            muted
            playsInline
            poster="" // optional: thumbnail image
          ></video>
          <div className="absolute inset-0 flex items-center justify-center">
            <button onClick={toggleMobilePlay} className="w-12 h-12 bg-opacity-80 rounded-full flex items-center justify-center shadow-md">
              {!isMobilePlaying && <img src="/assets/img/Group 6.png" className="h-full w-full"
             />}
             
            </button>
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden sm:block w-full max-w-4xl relative mt-8">
        <div className="absolute  left-[-20%] top-[30%] transform -translate-y-1/2 text-lg text-[#B9A287] font-atkinson leading-[1.1]  hidden md:flex flex-col justify-center items-center">
          Watch and discover <br /> how to apply <br />  in just a few clicks.
          <img src="/assets/img/Capa_2.png" className=" h-[130px]" />
        </div>

        <div className="relative rounded-xl overflow-hidden">

          <video
            src="/assets/video/istockphoto-1995708011-640_adpp_is.mp4"
            className="w-full h-auto object-cover"
            controls={false}
            ref={desktopVideoRef}
            loop
          
            playsInline
            poster="" // optional: thumbnail image
          ></video>
          <div className="absolute inset-0 flex items-center justify-center">
            <button onClick={toggleDesktopPlay} className="w-20 h-20  bg-opacity-80 rounded-full flex items-center justify-center shadow-lg">
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7 text-black"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg> */}

              {!isDesktopPlaying && <img src="/assets/img/Group 6.png" 
             
              className="h-full w-full"/>}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
